import React, { useState, useEffect } from "react";
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import _ from 'lodash';

const Main = ({ default_value, tree_options, value, onChange }) => {
  const [options, setOptions] = useState([]);
  const [filtered_options, setFilteredOptions] = useState([]);

  useEffect(() => {
    const new_options = convert_tree_to_options(tree_options);
    setOptions(new_options)
    setFilteredOptions(new_options)

    if (default_value !== undefined && !value?.value) {
      findByID(default_value, new_options)
    }
  }, [])

  useEffect(() => {
    if (default_value !== undefined && value == null && options.length > 0) {
      findByID(default_value, options)
    }
  }, [default_value])

  const convert_tree_to_options = (tree) => {
    let options = []
    tree.forEach((option) => {
      options.push(_.omit(option, ['children']))
      if (option.children) {
        options = options.concat(convert_tree_to_options(option.children))
      }
    })
    return options
  }

  const findByID = (id, options) => {
    const found = findOptionByID(options, id)
    if (found) {
      doSetValue(found)
      setFilteredOptions(options)
    }
  }

  const findOptionByID = (options, id) => {
    let found = null
    options.forEach((option) => {
      if (option.id == id) { found = option }
    })
    return found
  }

  const onLocalChange = (newValue) => {
    doSetValue(newValue)
    setFilteredOptions(options)
  }

  const doSetValue = (newValue) => {
    if(onChange) {
      onChange(newValue)
    }
  }

  const onSearch = (newValue) => {
    if (newValue == '') {
      setFilteredOptions(options)
    } else {
      setFilteredOptions(
        findButIncludeParent(options, newValue)
      )
    }
  }

  const findButIncludeParent = (options, newValue) => {
    const new_options = []
    var current_parent = null
    var current_parent_include = false

    options.forEach((option) => {
      if(option.child == false) {
        current_parent = option
        current_parent_include = false
      }

      if (option.name.toLowerCase().includes(newValue.toLowerCase())) {
        if(option.child == false) {
          new_options.push(option)
          current_parent_include = true
        } else {
          if(current_parent_include == false) {
            new_options.push(current_parent)
            current_parent_include = true
          }
          new_options.push(option)
        }
      }
    })

    return new_options
  }



  return (
    <>
      <Autocomplete
        value={value}
        options={filtered_options}
        sx={{ width: "100%" }}
        getOptionLabel={(option) => {
          if(typeof option === 'string') {
            return option
          } else if(option?.name) {
            return option.name
          } else {
            return ''
          }
        }}
        filterOptions={(x) => x}
        autoComplete
        autoSelect={true}
        includeInputInList
        filterSelectedOptions
        noOptionsText="Not found"
        onChange={(event, newValue) => {
          onLocalChange(newValue)
        }}
        onInputChange={(event, newInputValue) => {
          if(event) {
            onSearch(newInputValue)
          }
        }}
        renderInput={(params) => (
          <TextField {...params} fullWidth />
        )}
        renderOption={(props, option) => {
          const { key, ...optionProps } = props;
          return (
            <li key={key} {...optionProps} sx={{backgroundColor: 'red !important'}}>
              <Grid container sx={{ alignItems: 'center' }}>
                <Grid item sx={{ width: 'calc(100% - 44px)', wordWrap: 'break-word' }}>
                  {option.child == false ? <Typography variant="h7" sx={{ color: 'text.primary' }}>{option.name}</Typography> : null}
                  {option.child == true ? <Typography variant="body1" sx={{ color: 'text.primary', paddingLeft: "30px" }}>{option.name}</Typography> : null}
                </Grid>
              </Grid>
            </li>
          );
        }}
      />
    </>
  )
}

export default Main;
